export * from './services';
export * from './statebuilders/views';
export * from './stateProvider';
export * from './urlRouterProvider';
import './injectables';
import './directives/stateDirectives';
import './stateFilters';
import './directives/viewDirective';
import './viewScroll';
export default 'ui.router';
import * as core from '@uirouter/core';
export { core };
export * from '@uirouter/core';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/angular-ui-router/lib-esm/index.js
// module id = 8
// module chunks = 0